@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.utils

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json

object LocalizationManager {

    class LangEntry(val code: String, val name: String, val flag: String)

    val languages = listOf(
        LangEntry("de", "Deutsch", "de.svg"),
        LangEntry("en", "English", "us.svg"),
        LangEntry("bg", "Български", "bg.svg"),
        LangEntry("hr", "Hrvatski", "hr.svg"),
        LangEntry("cs", "Čeština", "cz.svg"),
        LangEntry("da", "Dansk", "dk.svg"),
        LangEntry("nl", "Nederlands", "nl.svg"),
        LangEntry("et", "Eesti", "ee.svg"),
        LangEntry("fi", "Suomi", "fi.svg"),
        LangEntry("fr", "Français", "fr.svg"),
        LangEntry("el", "Ελληνικά", "gr.svg"),
        LangEntry("hu", "Magyar", "hu.svg"),
        LangEntry("ga", "Gaeilge", "ie.svg"),
        LangEntry("it", "Italiano", "it.svg"),
        LangEntry("lv", "Latviešu", "lv.svg"),
        LangEntry("lt", "Lietuvių", "lt.svg"),
        LangEntry("mt", "Malti", "mt.svg"),
        LangEntry("pl", "Polski", "pl.svg"),
        LangEntry("pt", "Português", "pt.svg"),
        LangEntry("ro", "Română", "ro.svg"),
        LangEntry("sk", "Slovenčina", "sk.svg"),
        LangEntry("sl", "Slovenščina", "si.svg"),
        LangEntry("es", "Español", "es.svg"),
        LangEntry("sv", "Svenska", "se.svg"),
    )


    private var texts by mutableStateOf<Map<String, String>>(emptyMap())
    var currentLangCode by mutableStateOf("de")

    suspend fun initialize(defaultLang: String = "de") {
        if (texts.isEmpty()) load(defaultLang)
    }

    suspend fun load(langCode: String) {
        currentLangCode = langCode
        suspend fun loadMap(code: String): Map<String, String> {
            val response = try {
                window.fetch("/data/localization/${code}.json").await()
            } catch (_: Throwable) { null }
            val jsonText = response?.text()?.await()?.ifBlank { "{}" } ?: "{}"
            return try {
                Json.decodeFromString(jsonText)
            } catch (_: Throwable) {
                emptyMap()
            }
        }

        val de = loadMap("de")
        val selected = loadMap(langCode)
        texts = de + selected
    }

    fun get(key: String): String = texts[key] ?: "[$key]"

    // Flaggen liegen jetzt unter /images/flags/ als SVG
    fun flagPathFor(code: String): String =
        "images/flags/${languages.firstOrNull { it.code == code }?.flag ?: "de.svg"}"

}
